import {
  FormControl,
  FormControlLabel,
  FormControlLabelProps,
  FormHelperText,
  Radio,
  RadioGroup,
  RadioGroupProps,
  RadioProps,
} from '@material-ui/core';
import { ControllerRenderProps, FieldError, FieldValues, Path } from 'react-hook-form';

interface SelectOption {
  value: string;
  label: string;
  element: React.ReactElement;
  disabled?: boolean;
}

export interface CustomRadioFieldGroupProps<TFieldValues extends FieldValues>
  extends Omit<RadioProps, 'name' | 'error' | 'style'> {
  options: SelectOption[];
  field?: ControllerRenderProps<FieldValues, Path<TFieldValues>>;
  label?: string;
  error?: FieldError | undefined;
  radioProps?: Omit<RadioProps, 'name' | 'error'>;
  radioGroupProps?: Omit<RadioGroupProps, 'name' | 'error'>;
  formControlLabelProps?: Omit<FormControlLabelProps, 'control' | 'value' | 'label' | 'aria-label'>;
  OptionContainer?;
}

export function CustomRadioFieldGroup<TFieldValues extends FieldValues>({
  options,
  field,
  label,
  error,
  radioProps,
  radioGroupProps,
  formControlLabelProps,
  OptionContainer = 'div',
}: CustomRadioFieldGroupProps<TFieldValues>) {
  return (
    <FormControl fullWidth>
      <RadioGroup aria-label={label} {...field} value={field?.value ?? null} {...radioGroupProps}>
        {options.map((option) => (
          <OptionContainer key={option.value} isChecked={option.value === field?.value}>
            <FormControlLabel
              {...formControlLabelProps}
              control={<Radio {...radioProps} />}
              value={option.value}
              disabled={option.disabled}
              label={option.element}
              aria-label={option.label}
              style={{
                margin: 0,
                display: 'block',
                ...formControlLabelProps?.style,
              }}
            />
          </OptionContainer>
        ))}
      </RadioGroup>
      <FormHelperText error={!!error}>{error?.message}</FormHelperText>
    </FormControl>
  );
}
